/* eslint-disable */
// Categories
import c0 from '../assets/images/pics/MIC00004.webp';
import c1 from '../assets/images/pics/MIC00014.webp';
import c2 from '../assets/images/pics/MIC00034.webp';
import c3 from '../assets/images/pics/MIC00039.webp';

// Meals from category 1
import c1t1 from '../assets/images/pics/MIC00043.webp';
import c1t2 from '../assets/images/pics/MIC00050.webp';
import c1t3 from '../assets/images/pics/MIC00059.webp';
import c1t4 from '../assets/images/pics/MIC00070.webp';
import c1t5 from '../assets/images/pics/MIC00079.webp';
import c1t6 from '../assets/images/pics/MIC00090.webp';

// Meals from category 2
import c2t1 from '../assets/images/pics/MIC00095.webp';
import c2t2 from '../assets/images/pics/MIC00106.webp';
import c2t3 from '../assets/images/pics/MIC00107.webp';
import c2t4 from '../assets/images/pics/MIC00110.webp';
import c2t5 from '../assets/images/pics/MIC00118.webp';
import c2t6 from '../assets/images/pics/MIC00119.webp';
import c2t7 from '../assets/images/pics/MIC00108.webp';
import c2t8 from '../assets/images/pics/MIC00117.webp';
import c2t9 from '../assets/images/pics/MIC00120.webp';
import c2t10 from '../assets/images/pics/MIC00121.webp';


// Meals from category 3
import c3t1 from '../assets/images/pics/MIC00122.webp';
import c3t2 from '../assets/images/pics/MIC00128.webp';
import c3t3 from '../assets/images/pics/MIC00130.webp';
import c3t4 from '../assets/images/pics/MIC00131.webp';
import c3t6 from '../assets/images/pics/MIC00135.webp';

// Meals from category 4
import c4t1 from '../assets/images/pics/MIC00136.webp';
import c4t2 from '../assets/images/pics/MIC00138.webp';
import c4t3 from '../assets/images/pics/MIC00139.webp';
import c4t6 from '../assets/images/pics/MIC00143.webp';
import c4t7 from '../assets/images/pics/MIC00145.webp';
import c4t8 from '../assets/images/pics/MIC00151.webp';
import c4t9 from '../assets/images/pics/MIC03213.webp';
import c4t10 from '../assets/images/pics/halwa.webp';
import c4t11 from '../assets/images/pics/pista.webp';

// continue the sequence
import c5t1 from '../assets/images/pics/MIC00163.webp';
import c5t2 from '../assets/images/pics/MIC00166.webp';
import c6t2 from '../assets/images/pics/MIC00183.webp';
import c6t4 from '../assets/images/pics/MIC00190.webp';
import c6t5 from '../assets/images/pics/MIC00194.webp';
import c6t6 from '../assets/images/pics/MIC00199.webp';

import c7t1 from '../assets/images/pics/MIC00203.webp';
import c7t2 from '../assets/images/pics/MIC00207.webp';
import c7t3 from '../assets/images/pics/MIC00211.webp';
import c7t5 from '../assets/images/pics/MIC00220.webp';
import c7t6 from '../assets/images/pics/MIC00228.webp';

import c8t1 from '../assets/images/pics/MIC00230.webp';
import c8t5 from '../assets/images/pics/MIC00238.webp';
import c8t6 from '../assets/images/pics/MIC00239.webp';

import c9t1 from '../assets/images/pics/MIC00246.webp';
import c9t2 from '../assets/images/pics/MIC00252.webp';
import c9t3 from '../assets/images/pics/MIC00258.webp';
import c9t4 from '../assets/images/pics/MIC00262.webp';
import c9t5 from '../assets/images/pics/MIC00263.webp';
import c9t6 from '../assets/images/pics/MIC00271.webp';
import c9t7 from '../assets/images/pics/IMG_0062 2.webp';
import c9t8 from '../assets/images/pics/IMG_0006.webp';
import c9t9 from '../assets/images/pics/IMG_0051.webp';
import c9t10 from '../assets/images/pics/IMG_0053.webp';
import c9t11 from '../assets/images/pics/MIC_314.webp';
import c9t12 from '../assets/images/pics/MIC_654.jpeg';
import c9t13 from '../assets/images/pics/MIC_987.jpeg';


import c10t1 from '../assets/images/pics/MIC00274.webp';
import c10t2 from '../assets/images/pics/MIC00302.webp';
import c10t3 from '../assets/images/pics/MIC00306.webp';
import c10t4 from '../assets/images/pics/MIC00314.webp';
import c10t10 from '../assets/images/pics/MIC001281webp.webp';
import c10t11 from '../assets/images/pics/MIC00128zero.webp';

import c11t1 from "../assets/images/pics/MIC002383.jpg"
import c11t2 from "../assets/images/pics/MIC00435.jpeg"
import c11t3 from "../assets/images/pics/MIC00567.jpeg"
import c11t4 from "../assets/images/pics/MIC00867.jpeg"
import c11t5 from "../assets/images/pics/MIC0001.jpeg"


const ar1 = [
  {
    id: 0,
    src: c3,
    name: 'עוגת לוטוס',
    discription: '',
    price: 15,
    order: 0,
  },
  {
    id: 1,
    src: c2,
    name: 'עוגת אוריו',
    discription: '',
    price: 15,
    order: 0,
  },
  {
    id: 2,
    src: c1t1,
    name: 'עוגת טרילצ’ה',
    discription: '',
    price: 15,
    order: 0,
  },
  {
    id: 3,
    src: c1,
    name: 'עוגת פירות יער',
    discription: '',
    price: 30,
    order: 0,
  },
  {
    id: 4,
    src: c3t1,
    name: 'עוגת גבינה',
    discription: '',
    price: 30,
    order: 0,
  },
  {
    id: 5,
    src: c1t2,
    name: 'עוגת אום עלי',
    discription: '',
    price: 25,
    order: 0,
  },
  {
    id: 6,
    src: c0,
    name: 'עוגת דובאי',
    discription: '',
    price: 30,
    order: 0,
  },
];

const ar2 = [
    {
    id: 0,
    src: c9t3,
    name: 'קרפ דובאי',
    discription: '',
    price: 45,
    order: 0,
  },
  {
    id: 1,
    src: c7t6,
    name: 'וופל בלגי',
    discription: '',
    price: 30,
    order: 0,
  },
  {
    id: 2,
    src: c9t6,
    name: 'וופל בלגי קינדר',
    discription: '',
    price: 35,
    order: 0,
  },
    {
    id: 3,
    src: c9t11,
    name: 'וופל בלגי דובאי',
    discription: '',
    price: 35,
    order: 0,
  },

  {
    id: 4,
    src: c7t5,
    name: 'קרפ שוקולד',
    discription: '',
    price: 25,
    order: 0,
  },
  {
    id: 5,
    src: c10t4,
    name: 'קרפ קינדר',
    discription: '',
    price: 40,
    order: 0,
  },
  {
    id: 6,
    src: c8t6,
    name: 'פנקייק דובאי',
    discription: '2 קומות / 3 קומות',
    price: "35 / ₪45",
    order: 0,
  },
  {
    id: 7,
    src: c10t2,
    name: 'פנקייק קינדר',
    discription: '2 קומות / 3 קומות',
    price: "35 / ₪45",
    order: 0,
  },
  {
    id: 8,
    src: c10t3,
    name: 'פנקייק מייפל',
    discription: '2 קומות / 3 קומות',
    price: "25 / ₪35",
    order: 0,
  },
    {
    id: 9,
    src: c8t1,
    name: 'פשאפיש רגיל',
    discription: '10 קדורים / 15 קדורים',
    price: "25 / ₪35",
    order: 0,
  },
    {
    id: 10,
    src: c9t1,
    name: 'פשאפיש קינדר',
    discription: '10 קדורים / 15 קדורים',
    price: "30 / ₪40",
    order: 0,
  },
];

const ar3 = [
    {
    id: 0,
    src: c11t4,
    name: 'יוגורט',
    discription: 'קטן / גדול',
    price: "20 / ₪25",
    order: 0,
  },

];


const ar4 = [
  {
    id: 0,
    src: c9t7,
    name: 'עוגות לימי הולדת',
    discription: '',
    order: 0,
  },
  {
    id: 1,
    src: c9t10,
    name: 'עוגות לחתונות',
    discription: '',
    order: 0,
  },
  {
    id: 2,
    src: c9t9,
    name: 'עוגות לאירוסין',
    discription: '',
    order: 0,
  },
  {
    id: 3,
    src: c9t8,
    name: 'עוגות לאירועים שונים',
    discription: '',
    order: 0,
  },

];

const ar5 = [
  {
    id: 0,
    src: c1t4,
    name: 'קרואסון במילוי שוקולד',
    discription: '',
    price: 24,
    order: 0,
  },
  {
    id: 1,
    src: c1t3,
    name: 'קרואסון חמאה / שקדים',
    discription: '',
    price: "18 / ₪24",
    order: 0,
  },
  {
    id: 2,
    src: c1t6,
    name: 'קרואסון קינמון',
    discription: '',
    price: 22,
    order: 0,
  },
  {
    id: 3,
    src: c2t1,
    name: 'קרואסון פיסטוק / דובאי',
    discription: '',
    price: "22 / ₪30",
    order: 0,
  },
];

const ar6 = [
{
    id: 0,
    src: c2t5,
    name: 'אניס',
    discription: '',
    price: 30,
    order: 0,
  },
  {
    id: 1,
    src: c2t6,
    name: 'שוקולד וניל',
    discription: '',
    price: 30,
    order: 0,
  },
  {
    id: 2,
    src: c2t3,
    name: 'פיצוחים',
    discription: '',
    price: 30,
    order: 0,
  },
    {
    id: 3,
    src: c2t7,
    name: 'מלוחים',
    discription: '',
    price: 30,
    order: 0,
  },
    {
    id: 4,
    src: c2t8,
    name: 'מייפל ושקדים',
    discription: '',
    price: 30,
    order: 0,
  },
    {
    id: 5,
    src: c2t9,
    name: 'ריבה',
    discription: '',
    price: 30,
    order: 0,
  },
    {
    id: 6,
    src: c2t10,
    name: 'טחינה',
    discription: '',
    price: 30,
    order: 0,
  },
];

const ar7 = [    {
    id: 0,
    src: c10t1,
    name: 'אספרסו',
    discription: 'קצר / ארוך',
    price: "7 / ₪10",
    order: 0,
  },
  {
    id: 1,
    src: c8t5,
    name: 'קפוצינו',
    discription: 'קטן / גדול',
    price: "14 / ₪18",
    order: 0,
  },
  {
    id: 2,
    src: c9t5,
    name: 'מקיאטו',
    discription: '',
    price: 8,
    order: 0,
  },
  {
    id: 3,
    src: c9t2,
    name: 'שוקו',
    discription: 'קטן / גדול',
    price: "10 / ₪12",
    order: 0,
  },
  {
    id: 4,
    src: c6t2,
    name: 'אמריקנו',
    discription: '',
    price: 10,
    order: 0,
  },
    {
    id: 5,
    src: c9t4,
    name: 'תה בטעמים',
    discription: 'כוס / קנקן קטן / קנקן גדול',
    price: "10 / ₪18 / ₪24",
    order: 0,
  },
      {
    id: 6,
    src: c11t5,
    name: 'סחלב',
    discription: '',
    price: 15,
    order: 0,
  },
]; // שתיה חמה
const ar8 = [
  {
    id: 0,
    src: c5t1,
    name: 'אייס קפה',
    discription: 'קטן / גדול',
    price: "10 / ₪15",
    order: 0,
  },
  {
    id: 1,
    src: c5t2,
    name: 'אייס תות',
    discription: 'קטן / גדול',
    price: "10 / ₪15",
    order: 0,
  },
  {
    id: 2,
    src: c3t2,
    name: 'קוקה קולה',
    discription: '',
    price: 8,
    order: 0,
  },
  {
    id: 3,
    src: c10t11,
    name: 'קוקה קולה זירו',
    discription: '',
    price: 8,
    order: 0,
  },
  {
    id: 4,
    src: c10t10,
    name: 'פנטה',
    discription: '',
    price: 8,
    order: 0,
  },
    {
    id: 5,
    src: c3t4,
    name: 'ספרייט',
    discription: '',
    price: 8,
    order: 0,
  },
    {
    id: 6,
    src: c3t3,
    name: 'מים',
    discription: '',
    price: 6,
    order: 0,
  },
      {
    id: 7,
    src: c4t1,
    name: 'שוופס בטעמים',
    discription: '',
    price: 8,
    order: 0,
  },
]; // שתיה קרה

const ar9 = [
  {
    id: 0,
    src: c6t5,
    name: 'עוגת גבינה',
    discription: 'קטן / גדול',
    price: "90 / ₪130",
    order: 0,
  },
  {
    id: 1,
    src: c7t1,
    name: 'עוגת לוטוס',
    discription: '',
    price: 80,
    order: 0,
  },
  {
    id: 2,
    src: c6t6,
    name: 'עוגת פירות יער',
    discription: '',
    price: 90,
    order: 0,
  },
  {
    id: 3,
    src: c6t4,
    name: 'עוגת דובאי',
    discription: '',
    price: 90,
    order: 0,
  },
    {
    id: 4,
    src: c7t2,
    name: 'עוגת טרליצי',
    discription: '',
    price: 60,
    order: 0,
  },
];

const ar10 = [
  {
    id: 0,
    src: c4t3,
    name: 'עוגת קינמון',
    discription: '',
    price: 60,
    order: 0,
  },
  {
    id: 1,
    src: c4t8,
    name: 'עוגת שוקולד אגוזים',
    discription: '',
    price: 60,
    order: 0,
  },
  {
    id: 2,
    src: c4t6,
    name: 'עוגת נוטלה',
    discription: '',
    price: 60,
    order: 0,
  },
    {
    id: 3,
    src: c4t9,
    name: 'עוגת שקדים',
    discription: '',
    price: 60,
    order: 0,
  },
    {
    id: 4,
    src: c4t10,
    name: 'עוגת חלווה',
    discription: '',
    price: 60,
    order: 0,
  },
    {
    id: 5,
    src: c4t11,
    name: 'עוגת פיסטוק',
    discription: '',
    price: 60,
    order: 0,
  },
];

const ar11 = [
  {
    id: 0,
    src: c11t1,
    name: 'מוחיטו',
    discription: 'תות, אבטיח, בלו בירי',
    price: 15,
    order: 0,
  },
    {
    id: 1,
    src: c9t12,
    name: 'שייק פירות',
    discription: 'מנגו, תות, פסיפלורה',
    price: 20,
    order: 0,
  },
      {
    id: 2,
    src: c9t13,
    name: 'מילק שייק',
    discription: 'דרדסים, שוקולד, וניל',
    price: 20,
    order: 0,
  },
];

const catagories = [
    {
    id: 0,
    name: 'מאפים',
    src: c1t5,
    list: ar5,
  },
  {
    id: 1,
    name: 'קינוחים',
    src: c9t3,
    list: ar2,
  },
   {
    id: 2,
    name: 'יוגורטים',
    src: c11t4,
    list: ar3,
  },
    {
    id: 3,
    name: 'עוגות אישיות',
    src: c1t2,
    list: ar1,
  },
      {
    id: 4,
    name: 'עוגות שמרים',
    src: c4t9,
    list: ar10,
  },
      {
    id: 5,
    name: 'עוגות בטעמים',
    src: c7t2,
    list: ar9,
  },
  {
    id: 6,
    name: 'עוגות לאירועים',
    src: c9t8,
    list: ar4,
  },
  {
    id: 7,
    name: 'ביסקוויטים',
    src: c2t5,
    list: ar6,
  },
  {
    id: 8,
    name: 'שתיה חמה',
    src: c6t2,
    list: ar7,
  },
      {
    id: 9,
    name: 'משקאות מיוחדים',
    src: c11t1,
    list: ar11,
  },
  {
    id: 10,
    name: 'שתיה קרה',
    src: c3t2,
    list: ar8,
  },

];

export default catagories;
